import { render } from "./ObstetricalPage.vue?vue&type=template&id=391af868"
import script from "./ObstetricalPage.vue?vue&type=script&lang=js"
export * from "./ObstetricalPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__